module.exports = __webpack_public_path__ + "static/img/1.d9a45ddc.jpeg";